import { useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function RefreshButton({
  onRefresh,
  label = "Refresh",
  testId = "refresh-btn",
  className = "",
}) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onRefresh();
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handleClick}
      disabled={busy}
      title={label}
      aria-label={label}
      className={`btn-touch inline-flex items-center gap-1.5 px-3 py-2 text-xs font-mono-d uppercase tracking-widest border border-app-border hover:bg-app-hover hover:border-app-border-strong disabled:opacity-50 transition-colors ${className}`}
    >
      <ArrowsClockwise size={14} className={busy ? "animate-spin" : ""} />
      {busy ? "Refreshing…" : label}
    </button>
  );
}
